export default "__VITE_ASSET__e938304a__"